import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_TICKLIGNE_SCHEMA_LITERAL = {
    title: 'Schéma LigneTicket',
    description: 'Ticket',
    version: 14,
    keyCompression: false,
    primaryKey: 'PK_ID',
    type: 'object',
    properties: {
        MD_DOGID : { type : 'string' },
        PK_ID : { type : 'string', maxLength : 100 },
        MD_SITEGID : { type : 'string' },
        MD_SITE : { type : 'string' },
        MD_CAISSE : { type : 'string' },
        MD_CAISSIERGID : { type : 'string' },
        MD_CAISSIER : { type : 'string' },
        MD_CAISSE_SESSION : { type : 'string' },
        MD_LOCALGID : { type : 'string' },
        MD_DATE_CREATION : { type : 'string' },
        MD_CBMARQ : { type : 'number' },
        DL_NO : { type : 'number' },
        DO_PIECE : { type : 'string' },
        DO_PIECE_INTERNAL : { type : 'string' },
        DL_LIGNE: { type: 'number' },
        DE_NO: { type: 'number' },
        DE_INTITULE: { type: 'string' },
        AR_REF: { type: 'string', default : '' },
        FA_CODEFAMILLE: { type: 'string', default : '' },
        AR_REFCOMPOSE: { type: 'string', default : '' },
        DL_DESIGN: { type: 'string' },
        AG_NO1: { type: 'number' },
        AG_NO1LIB: { type: 'string', default : '' },
        AG_NO2: { type: 'number' },
        AG_NO2LIB: { type: 'string', default : '' },
        AR_SUIVISTOCK : { type : 'number' },
        LS_NOSERIE : { type : 'string' },
        LS_COMPLEMENT : { type : 'string' },
        LS_PEREMPTION : { type : ['string', 'null'] },
        LS_FABRICATION : { type : ['string', 'null'] },
        LS_QTE : { type : 'number' },
        DL_QTE: { type: 'number' },
        DL_PRIXUNITAIRE: { type: 'number' },
        DL_PRIXUNITAIRE_NC: { type: 'number' },
        DL_REMISE01REM_VALEUR: { type: 'number' },
        DL_REMISE01REM_TYPE: { type: 'number' },
        DL_REMISE02REM_VALEUR: { type: 'number' },
        DL_REMISE02REM_TYPE: { type: 'number' },
        DL_REMISE03REM_VALEUR: { type: 'number' },
        DL_REMISE03REM_TYPE: { type: 'number' },
        DL_REMISE_LIB: { type: ['string', 'null'] },
        DL_REMISE_MT: { type: ['number', 'null'] },
        DL_TAXE1: { type: 'number' },
        DL_CODETAXE1: { type: 'string' },
        DL_TYPETAUX1: { type: 'number' },
        DL_TYPETAXE1: { type: 'number' },
        DL_TAXE2: { type: 'number' },
        DL_CODETAXE2: { type: 'string' },
        DL_TYPETAUX2: { type: 'number' },
        DL_TYPETAXE2: { type: 'number' },
        DL_TAXE3: { type: 'number' },
        DL_CODETAXE3: { type: 'string' },
        DL_TYPETAUX3: { type: 'number' },
        DL_TYPETAXE3: { type: 'number' },
        EU_QTE: { type: 'number' },
        EU_ENUMERE: { type: 'string' },
        DL_TTC: { type: 'number', default : 0 },
        DL_PUTTC: { type: 'number', default : 0 },
        DL_PUTTC_NC: { type: 'number', default : 0 },
        DL_MONTANTHT: { type: 'number', default : 0 },
        DL_MONTANTTTC: { type: 'number', default : 0 },
        DL_MONTANTTTC_AVANTREMISE: { type: 'number', default : 0 },
        DL_VALORISE : { type : 'number', default : 0 },
        DL_TIMBRE : { type : 'number', default : 0 },
        DL_REMISEG : { type : 'number', default : 0 },
        DL_NOSOUSTOTAL: { type: 'number', default : 0 },
        EST_SOUSTOTAL: { type: 'boolean', default : false },
        NBLIGNES_SOUSTOTAL : { type: 'number', default : 0 },
        DL_LCREC: { type: 'number' },
        DL_LCREC_DATE: { type: ['string', 'null'] },
        LC_REC_PTS_NB: { type: 'number' },
        LC_PG_GID: { type: ['string', 'null'] },
        LC_REC_GID: { type: ['string', 'null'] },
        LC_REC_TYPE: { type: 'number' },
        DL_GIFTCARD: { type: 'boolean' },
        DL_GF_CARTE_NUM: { type: ['string', 'null'] },
        DL_GF_CARTE_DESIGNATION: { type: ['string', 'null'] },
        DL_GF_C_TOTAL_TTC_INIT: { type: 'number' },
        DL_GF_DATE_DEBUT: { type: ['string', 'null'] },
        DL_GF_DATE_EXP: { type: ['string', 'null'] },
        CL_EXTRAS  : { type : ['string', 'null'] }, 
        Z_CHECKED: { type: 'boolean', default : false }
    },
    required: [ 'MD_CBMARQ', 'DL_NO', 'DO_PIECE', 'DO_PIECE_INTERNAL', 'DL_LIGNE', 'DL_QTE', 'DL_PRIXUNITAIRE', 'DL_MONTANTHT', 'DL_MONTANTTTC', 'DL_NOSOUSTOTAL' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_TICKLIGNE_SCHEMA_LITERAL);
export type RxCluTickLigneDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_TICKLIGNE_SCHEMA: RxJsonSchema<RxCluTickLigneDocumentType> = CLU_TICKLIGNE_SCHEMA_LITERAL;
